import { atom } from 'recoil'

export const loginModalOpenState = atom<boolean>({
  key: 'loginModalOpenState',
  default: false,
})

// 登录弹窗的打开来源场景（漏斗曝光维度）。一期默认 unknown，
// 二期由 openLogin(source) 在各触发点写入具体场景。
export const loginSourceState = atom<string>({
  key: 'loginSourceState',
  default: 'unknown',
})

export const logoutModalOpenState = atom<boolean>({
  key: 'logoutModalOpenState',
  default: false,
})
